import {
  Component,
  OnInit,
  ViewChild,
  OnDestroy,
  ChangeDetectionStrategy,
  signal,
  AfterViewInit,
  inject,
} from "@angular/core";
import { MatSidenav, MatSidenavModule } from "@angular/material/sidenav";

import { Subscription } from "rxjs";

import {
  Router,
  NavigationStart,
  NavigationEnd,
  NavigationCancel,
  NavigationError,
  Event,
  RouterOutlet,
} from "@angular/router";

import { SidenavService } from "projects/jtms-front-end/src/app/layout/main-layout/sidenav/sidenav.service";
import { MatProgressBarModule } from "@angular/material/progress-bar";

import { NavTreeComponent } from "../nav-tree/nav-tree.component";
import { select } from "@ngxs/store";
import { LayoutState } from "@dis/shared";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";
import { NgTemplateOutlet } from "@angular/common";
import { AlertHeaderComponent } from "../alert-header/alert-header.component";
import { ActionSidenavService } from "../action-sidenav/action-sidenav.service";
import { ActionSidenav } from "../action-sidenav/action-sidenav.component";

@Component({
  selector: "app-sidenav",
  templateUrl: "./sidenav.component.html",
  styleUrls: ["./sidenav.component.scss"],
  imports: [
    MatSidenavModule,
    MatProgressBarModule,
    RouterOutlet,
    NavTreeComponent,
    AlertHeaderComponent,
    MatButtonModule,
    MatIconModule,
    ActionSidenav,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SidenavComponent implements OnInit, OnDestroy, AfterViewInit {
  fixedInViewPort = false;

  // loading$ = new BehaviorSubject(false);
  isHandset = select(LayoutState.isHandset);
  loading = signal<boolean>(false);

  protected readonly actionSidenavService = inject(ActionSidenavService);

  // Viewport params
  @ViewChild("sidenav", { static: false }) public sidenav!: MatSidenav;

  routerSubscription!: Subscription;

  constructor(
    private router: Router,
    public sidenavService: SidenavService
  ) {
    this.routerSubscription = this.router.events.subscribe((event: Event) => {
      switch (true) {
        case event instanceof NavigationStart: {
          // this.loading$.next(true);
          this.loading.set(true);
          if (this.isHandset()) {
            this.sidenavService.close().then(() => {});
          }
          break;
        }
        case event instanceof NavigationEnd:
        case event instanceof NavigationCancel:
        case event instanceof NavigationError: {
          this.loading.set(false);
          // this.loading$.next(false);
          break;
        }
        default: {
          break;
        }
      }
    });
  }

  ngOnInit() {}

  ngAfterViewInit() {
    // Store Sidenavs to service
    this.sidenavService.setSidenav(this.sidenav);
  }

  ngOnDestroy() {
    this.routerSubscription.unsubscribe();
  }
}
